// extracted by mini-css-extract-plugin
export default {"container":"p-SUR","hiddenBalance":"HpVKZ","hiddenBalanceValue":"R3wwf","accentIcon":"_1UDUn"};